import classNames from 'classnames';
import _ from 'lodash';
import React, { useState } from 'react';
import { Link } from '../utils/router/v3Bridge';
import Caret from '../components/Caret';
import SVGIcon from '../components/SVGIcon';
import { BEACON_TOPIC_SIDEBAR } from '../constants/onboarding';
import topicIcon from '../icons/prefilled/topic.svg';
import TutorialBeacon from '../onboarding/tutorial/TutorialBeacon';
import TopicNameWithIcon from '../topic/TopicNameWithIcon';
import topicPath from '../utils/url/topicPath';
import styles from './TopicItem.module.scss';
import TopicItemMenu from './TopicItemMenu';
import type { AllTopicsTreeListTopic } from '../topic/useAllTopics';

const stopEvent = (e: React.MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
};

interface TopicItemProps {
  active?: boolean;
  alignToIcon?: boolean;
  expanded?: boolean;
  first?: boolean;
  level?: number;
  onToggleExpand: () => void;
  showIcon?: boolean;
  topic: AllTopicsTreeListTopic;
}

const TopicItem = ({
  active,
  alignToIcon,
  expanded,
  first,
  level = 0,
  onToggleExpand,
  showIcon,
  topic,
}: TopicItemProps) => {
  const { childTopics } = topic;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleCaretClick = (e: React.MouseEvent) => {
    onToggleExpand();
    stopEvent(e);
  };

  return (
    <TutorialBeacon id={BEACON_TOPIC_SIDEBAR} hide={!active} placement="right">
      {(beaconProps) => (
        <li
          className={classNames(styles.container, {
            [styles.active]: active,
            [styles.childless]: !childTopics.length,
            [styles.menuOpen]: isMenuOpen,
            [styles.firstChild]: first,
          })}
          {...beaconProps}
        >
          <div className={styles.rightContent}>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited */}
            <div className={styles.menu} onClick={stopEvent}>
              <TopicItemMenu
                open={isMenuOpen}
                onOpenChange={setIsMenuOpen}
                topic={topic}
              />
            </div>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited */}
            <div className={styles.caretContainer} onClick={handleCaretClick}>
              <Caret direction={expanded ? 'up' : 'down'} size={10} />
            </div>
          </div>
          <Link
            to={topicPath(topic)}
            className={classNames(styles.link, styles.topic, {
              [styles.active]: active,
            })}
          >
            {showIcon && (
              <SVGIcon size={12} className={styles.icon}>
                {topicIcon}
              </SVGIcon>
            )}
            {alignToIcon && <div className={styles.iconAlignment} />}
            {_.times(level, (index) => (
              <div
                key={index}
                className={classNames(styles.indentLine, {
                  [styles.last]: index === level - 1,
                })}
              />
            ))}
            <div className={styles.name}>
              <TopicNameWithIcon
                topic={topic}
                iconSize="regular"
                truncate="multi"
              />
            </div>
          </Link>
        </li>
      )}
    </TutorialBeacon>
  );
};

export default TopicItem;
